import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "../css/home.css";
import Swiper from "../components/Swiper";
import styled from "styled-components";

const TechniqueItem = styled(Link)`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 278px;
  height: 261px;
  background-blend-mode: multiply;
  box-sizing: border-box;
  border-radius: 16px;
  cursor: pointer;
  text-decoration: none;
  background-repeat: no-repeat;
  background-size: 130%;
  background-position: center;
  transition: background-size 0.4s ease !important;
  padding: 16px;
  justify-content: flex-end;
  background-image: linear-gradient(
      0deg,
      rgba(24, 24, 27, 1) 25%,
      rgba(115, 115, 129, 0) 100%
    ),
    url(${(props) => props.backgroundImage});

  &:hover {
    background-size: 140% !important;
  }

  & > .technique-name {
    font-size: 18px;
  }

  @media (max-width: 426px) {
    width: auto;
    height: auto;
    aspect-ratio: 1/1;
    gap: 8px;

    & > .technique-name {
      font-size: 14px;
    }

    & > p:last-child {
      font-size: 12px !important;
    }
  }
`;

function Homepage() {
  const [techniques, setTechniques] = useState([]);

  useEffect(() => {
    axios
      .get(
        `https://jiujitsu-json-data.s3.ap-northeast-2.amazonaws.com/jiujitsu/jiujitsu_techniques.json?v=${Date.now()}`
      )
      .then((resp) => {
        setTechniques(resp.data);
      });
  }, []);

  const techniquesList = techniques.map((data, index) => {
    return (
      <TechniqueItem
        className="box"
        key={index}
        to={`/tech/${data.techniqueName}`}
        backgroundImage={data.backgroundImage}
      >
        <p
          className="technique-name"
          style={{
            color: "#fff",
          }}
        >
          {data.techniqueName.replace(/([a-z])([A-Z])/g, "$1 $2")}
        </p>
        <p
          style={{
            fontSize: "14px",
            color: "#BD1236",
          }}
        >
          자세히 보기 →
        </p>
      </TechniqueItem>
    );
  });

  return (
    <main className="main-homepage">
      <Swiper></Swiper>
      <div className="section">
        <p className="title">Techniques</p>
        <div className="container">{techniquesList}</div>
      </div>
    </main>
  );
}

export default Homepage;
